class Tracking {
  constructor() {
    this.ec = {
      addProductImpression: (products, list) => {
        return this.addProductImpression(products, list)
      },
      clickProduct: (product, list, position) => {
        return this.clickProduct(product, list, position)
      },
      addToCart: (product, productInstanceId, quantity) => {
        return this.addToCart(product, productInstanceId, quantity)
      },
      removeFromCart: (product, productInstance, quantity) => {
        return this.removeFromCart(product, productInstance, quantity)
      },
      checkout: (cart) => {
        const cartModel = _cloneDeep(cart)
        return this.checkout(cartModel)
      },
    }
  }

  addProductImpression(products, list = null) {
    if(!window.ga) return
    if(!Array.isArray(products)) return
    for(const index in products) {
      const product = products[index]
      let params = {
        id: product.id,
        name: product.name,
        category: !product.category ? undefined : product.category.name,
        brand: !product.brand ? undefined : product.brand.name,
        list: list || undefined,
        position: index,
        price: product.price,
      }
      ga('ec:addImpression', params)
    }
  }

  _addProductFieldObject(product, list = undefined, position = undefined) {
    let params = {
      id: product.id,
      name: product.name,
      category: !product.category ? undefined : product.category.name,
      brand: !product.brand ? undefined : product.brand.name,
      price: product.price,
    }
    if(position != undefined) params.position = position

    ga('ec:addProduct', {
      id: product.id,
      name: product.name,
      category: !product.category ? undefined : product.category.name,
      brand: !product.brand ? undefined : product.brand.name,
      list: list || undefined,
      position: position,
      price: product.price,
    })
  }

  clickProduct(product, list, position = undefined) {
    if(!window.ga) return
    this._addProductFieldObject(product, list, position)
    ga('ec:setAction', 'click', { list })
    ga('ec:setAction', 'detail')
  }

  addToCart(product, productInstanceId, quantity) {
    if(!window.ga) return
    const instance = product.instances.find(instance => instance.id === productInstanceId)
    let params = {
      id: product.id,
      name: product.name,
      category: !product.category ? null : product.category.name,
      price: instance.price,
      quantity: quantity,
      brand: !product.brand ? null : product.brand.name,
      variant: !product.multi_models ? null : instance.name
    }

    ga('ec:addProduct', params)
    ga('ec:setAction', 'add')
  }

  removeFromCart(product, productInstance, quantity) {
    if(!window.ga) return
    let params = {
      id: product.id,
      name: product.name,
      category: !product.category ? null : product.category.name,
      price: productInstance.price,
      quantity: quantity,
      brand: !product.brand ? null : product.brand.name,
      variant: !product.multi_models ? null : productInstance.name
    }

    ga('ec:addProduct', params)
    ga('ec:setAction', 'remove')
  }

  checkout(cart) {
    if(!window.ga) return
    for(const cartItem of cart.items) {
      const product = cartItem.product
      const productInstance = cartItem.product_instance
      let params = {
        id: product.id,
        name: product.name,
        category: !product.category ? null : product.category.name,
        price: productInstance.price,
        quantity: cartItem.quantity,
        brand: !product.brand ? null : product.brand.name,
        variant: !product.multi_models ? null : productInstance.name
      }

      // ga('ec:addProduct', params)
      // ga('ec:setAction','checkout')
    }
  }
}

export default new Tracking()